const platform = 'WEB'

export const isIOS = () => {
  const possibleUserAgents = [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
  ]
  if (!window?.navigator) return false
  const userAgent = window.navigator.userAgent
  return possibleUserAgents.some(iosUserAgent => userAgent.includes(iosUserAgent))
}

export default platform
